import Button from "atoms/buttons/button";
import { ButtonSizes } from "atoms/constants/button-sizes";
import { ButtonStyles } from "atoms/constants/button-styles";
import { IconSizes } from "atoms/constants/icon-sizes";
import { Icons } from "atoms/constants/icons";
import Icon from "atoms/icons/icon";
import { HubspotFormConstants } from "constants/hubspot-form-contants";
import { ModalCloseButtonStyle } from "molecules/constants/modal-close-button-style";
import { ModalTypes } from "molecules/constants/modal-types";
import Modal from "molecules/modals/modal";
import HubspotForm from "organisms/forms/hubspot-form";
import React, { ReactNode, useRef } from "react";
import { useLocalization } from "utilities/hooks/use-localization";
import { ToastManager } from "utilities/toast/toast-manager";
// -----------------------------------------------------------------------------------------
// #region Interfaces
// -----------------------------------------------------------------------------------------

interface ContactModalProps {
    closeDialog: () => void;
    isVisible: boolean;
    returnURL?: string;
    selectedReasonOption?: string;
    children?: ReactNode;
}

// #endregion Interfaces

// -----------------------------------------------------------------------------------------
// #region Constants
// -----------------------------------------------------------------------------------------

const CSS_BASE_CLASS_NAME = "c-contact-modal";

// #endregion Constants

// -----------------------------------------------------------------------------------------
// #region Component
// -----------------------------------------------------------------------------------------

const ContactModal: React.FunctionComponent<ContactModalProps> = (props) => {
    const { closeDialog, isVisible, selectedReasonOption } = props;
    const { t } = useLocalization();

    const modalContentRef = useRef<HTMLDivElement>(null);

    const handleOnSuccess = () => {
        ToastManager.success(t("supportPage-messageConfirmation"));
        closeDialog();
    };

    const handleOnError = () => {
        modalContentRef.current?.scrollTo(0, 0);
    };

    const onClose = () => {
        if (closeDialog != null) {
            closeDialog();
        }
    };

    const modalHeading = t("contactModal-heading");

    const defaultReasonForOrDefault = selectedReasonOption
        ? { [HubspotFormConstants.REASON_FIELD_NAME]: selectedReasonOption }
        : {};

    return (
        <Modal
            closeButtonStyle={ModalCloseButtonStyle.InsideDialog}
            closeDialog={closeDialog}
            cssClassName={CSS_BASE_CLASS_NAME}
            isVisible={isVisible}
            label={modalHeading}
            type={ModalTypes.Base}>
            <div className={`${CSS_BASE_CLASS_NAME}__header`}>
                <h2>{modalHeading}</h2>
                <Button
                    accessibleText={t("close")}
                    cssClassName={"-modal-close -icon"}
                    onClick={onClose}
                    size={ButtonSizes.Medium}
                    style={ButtonStyles.Tertiary}>
                    <Icon type={Icons.Close} size={IconSizes.Large} />
                </Button>
            </div>
            <div
                className={`${CSS_BASE_CLASS_NAME}__content`}
                ref={modalContentRef}>
                <HubspotForm
                    formId={HubspotFormConstants.CONTACT_MODAL_FORM_ID}
                    onError={handleOnError}
                    onSuccess={handleOnSuccess}
                    defaultValues={defaultReasonForOrDefault}
                />
            </div>
        </Modal>
    );
};

// #endregion Component

// -----------------------------------------------------------------------------------------
// #region Export
// -----------------------------------------------------------------------------------------

export default ContactModal;

// #endregion Export
